import React from 'react'
import styled from 'styled-components'
import FooterLogo from '../../assets/svg/logoFooter.inline.svg'
import DownloadIcon from '../../assets/svg/downloadIcon.inline.svg'
import Container from '../atoms/Container'
import {graphql, Link, useStaticQuery} from 'gatsby'
import SubscribeForm from '../atoms/SubscribeForm'
import {useStore} from '../../utils/store'

const Holder = styled.footer`
  padding: 3rem 0;
  background-color: ${props => props.theme.colours.black3};
`

const Grid = styled.div`
  color: ${props => props.theme.colours.white};
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem;
  @media ( ${props => props.theme.breakpoints.lg} ) {
    grid-template-columns: repeat(4, auto);
    justify-content: start;
    grid-gap: 4rem;
  }

  ul {
    list-style: none;
    padding-left: 0;
    margin: 0;

    a {
      text-decoration: none;

      svg {
        height: 0.75rem;
        width: auto;
        display: inline-block;
        margin-left: 0.5rem;
      }
    }
  }

  p {
    margin: 0;
  }

  li, p, button {
    ${(props) => props.theme.fluidType(-1)};
  }
`


const LogoHolder = styled.div`
  svg {
    width: 13rem;
    height: auto;
  }
`

function Footer({hide}) {

    const openContact = useStore(state => state.openContact)
    const data = useStaticQuery(graphql`
    query FooterQuery {
      prismicWhyGoElectricPage {
        data {
          info_sheet {
            url
          }
        }
      }
    }
  `)

    if (hide) return null

    return (
        <Holder>
            <Container>
                <Grid>
                    <LogoHolder>
                        <FooterLogo/>
                    </LogoHolder>
                    <nav>
                        <ul>
                            <li><Link to="/about">About Us</Link></li>
                            <li><a target="_blank" rel="noopener noreferrer"
                                   href="https://www.linkedin.com/company/highlandelectricfleets/">LinkedIn</a></li>
                            <li><Link to="/about#news">In the News</Link></li>
                            <li><Link to="/privacy">Privacy Policy</Link></li>
                        </ul>
                    </nav>
                    <nav>
                        <ul>
                            <li><a href="tel:+19782881105" target="_blank" rel="noopener noreferrer">978.288.1105</a>
                            </li>
                            <li>
                                <button onClick={() => openContact()} className="link">Contact Us</button>
                            </li>
                            <li><a href={data.prismicWhyGoElectricPage.data.info_sheet.url} target="_blank"
                                   rel="noopener noreferrer">Download Info Sheet<DownloadIcon/></a></li>
                        </ul>
                    </nav>
                    <div>
                        <p>Subscribe to Our Newsletter</p>
                        <SubscribeForm/>
                    </div>
                </Grid>
            </Container>
        </Holder>
    )
}

export default Footer
